import { ExpressionSpecification } from 'shared/map-exports';
import { METERS_PER_SEC_TO_MPH_FACTOR } from 'features/weatherStations/weatherStations.constants';
import { SnakeCaseAttributeKey } from './WeatherStationsLayer.types';

export const getValueDisplayExpression = (
  attribute: SnakeCaseAttributeKey,
  returnType: 'number' | 'string' = 'number',
): ExpressionSpecification => {
  let expression: ExpressionSpecification;

  if (attribute === 'air_temp' || attribute === 'dew_point_temperature') {
    // Celsius to Fahrenheit
    expression = ['+', ['*', ['get', attribute], 9 / 5], 32];
  } else if (attribute === 'wind_gust' || attribute === 'wind_speed') {
    // Meters per second to miles per hour
    expression = ['*', ['get', attribute], METERS_PER_SEC_TO_MPH_FACTOR];
  } else {
    // No conversion needed
    expression = ['get', attribute];
  }

  if (returnType === 'string') {
    return ['number-format', expression, { 'max-fraction-digits': 1 }];
  }

  return expression;
};
